import { z } from "zod";

export const Role = z.enum(["OWNER", "STAFF"]);
export const LeadStatus = z.enum(["NEW", "CONTACTED", "QUALIFIED", "CONVERTED", "LOST"]);
export const LeadSource = z.enum(["WEBSITE", "REFERRAL", "WALK_IN", "OTHER"]);
export const ClientStatus = z.enum(["ACTIVE", "ARCHIVED"]);
export const DocType = z.enum([
  "LICENSE_FRONT", "LICENSE_BACK", "INSURANCE", "RENTAL_AGREEMENT", "SECONDARY_DRIVER", "MISC",
]);
export const RentalStatus = z.enum([
  "UPCOMING", "ACTIVE", "ENDING_SOON", "COMPLETED", "TERMINATED_EARLY", "CANCELLED",
]);
export const PaymentDueStatus = z.enum(["UPCOMING", "DUE", "PAID", "PARTIAL", "OVERDUE"]);
export const PaymentMethod = z.enum(["CASH", "ZELLE", "CHECK", "CARD", "WIRE", "OTHER"]);
export const VehicleStatus = z.enum(["AVAILABLE", "RESERVED", "RENTED", "IN_SHOP", "INACTIVE"]);
export const FuelType = z.enum(["GAS", "DIESEL", "HYBRID", "ELECTRIC", "OTHER"]);
export const ShopVisitStatus = z.enum(["IN_SHOP", "READY_FOR_PICKUP", "RETURNED"]);
export const DepositStatus = z.enum(["HELD", "RETURNED", "PARTIALLY_RETURNED"]);

export type Role = z.infer<typeof Role>;
export type LeadStatus = z.infer<typeof LeadStatus>;
export type RentalStatus = z.infer<typeof RentalStatus>;
export type PaymentDueStatus = z.infer<typeof PaymentDueStatus>;
export type VehicleStatus = z.infer<typeof VehicleStatus>;
export type ShopVisitStatus = z.infer<typeof ShopVisitStatus>;
